import { map, pick } from 'lodash'

const transformToSaveAllergensArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, ['id', 'name', 'isCurationEnabled', 'position']),
    position: index,
  }))

export default transformToSaveAllergensArgs
